<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="100px" class="ele-form-search" @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="所属链">
              <el-input v-model.trim="where.chain" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="钱包地址">
              <el-input v-model.trim="where.address" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="名称">
              <el-input v-model.trim="where.label" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="状态">
              <el-select v-model="where.status" clearable placeholder="请选择" class="ele-fluid">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 355px)">
        <template slot="toolbar">
          <el-button size="small" type="primary"
            icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">添加</el-button>
          <el-button size="small" type="danger"
            icon="el-icon-delete" class="ele-btn-icon" :disabled="!selection.length" @click="removeBatch">删除</el-button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="editStatus(row)" />
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary"
            class="ele-btn-icon" @click="openEdit(row)">编辑</el-button>
          <el-popconfirm class="ele-action"
            title="确定要删除此记录吗？" @confirm="remove(row)">
            <el-button slot="reference" size="small" type="danger" class="ele-btn-icon">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <walletlist-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';
import WalletlistEdit from './walletlist-edit';

export default {
  name: 'WalletList',
  components: { WalletlistEdit },
  data() {
    return {
      url: '/WalletList/index',
      statusOptions: [],
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 70, align: 'center' },
        { prop: 'label', label: '名称', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'chain', label: '所属链', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { prop: 'address', label: '钱包地址', minWidth: 220, align: 'center', showOverflowTooltip: true },
        { prop: 'balance', label: '余额', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'status', label: '状态', width: 100, align: 'center', slot: 'status' },
        { prop: 'note', label: '备注', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'create_time', label: '创建时间', minWidth: 160, align: 'center', showOverflowTooltip: true },
        { columnKey: 'action', label: '操作', width: 160, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false
    };
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/WalletList/status', { id: row.id, status: row.status }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = row.status === 1 ? 2 : 1;
        this.$message.error(e.message);
      });
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/WalletList/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的记录吗？', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/WalletList/delete', { id: this.selection.map((d) => d.id) }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>
